export default {
    whichWill: {
        title: 'Which Will Service Is Best For Me | {{country}}',
        description: 'Answer some questions to figure out which Will service best fits your needs.',
        keywords: '{{country}} Will Service Options, Questionnaire, Best for me',
        whichWill: 'Which Will service is best for me',
    },
};
